import module from 'kendu/legacy/module'
import { forEach } from 'lodash'

module.directive('uiValidators', () => ({
  restrict: 'A',
  require: 'ngModel',
  link (scope, element, attrs, ngModel) {
    let validators = scope.$eval(attrs['uiValidators'])

    forEach(validators, (value, key) => (ngModel.$validators[key] = value))
  },
}))



// WEBPACK FOOTER //
// ./src/deprecated/directive/ui-validators/component.js